import React from 'react';
import styled from '@emotion/styled';

const MIN_CONTENT_PADDING_PX = 20;

const Header = styled.div`
    padding-top: ${MIN_CONTENT_PADDING_PX}px;
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 400px;
    max-width: calc(100vw - ${2 * MIN_CONTENT_PADDING_PX}px);
    min-height: 100vh;
    margin: 0 auto;
`;

const InnerContent = styled.div`
    flex-grow: 1;
    display: flex;
`;

const Footer = styled.div`
    padding-bottom: 1.5rem;
`;

type LayoutProps = {
    header?: React.ReactNode;
    content?: React.ReactNode;
    footer?: React.ReactNode;
    children?: never;
};

export const Layout: React.FC<LayoutProps> = ({ header, content, footer }) => {
    return (
        <Container>
            {header && <Header>{header}</Header>}
            <InnerContent>{content}</InnerContent>
            {footer && <Footer>{footer}</Footer>}
        </Container>
    );
};

export default Layout;
